import ResponsiveLayoutMobileProvider from './hooks/useResponsiveLayoutMobile';

import { ResponsiveLayoutMobileProps } from './@types/ResponsiveLayoutMobileProps';
import { selectedToggleValue } from '../../../redux/canvasResolutionSlice';
import { useSelector } from 'react-redux';

const ResponsiveLayoutMobile = (props: ResponsiveLayoutMobileProps) => {
	const selectedCanvasResolution = useSelector(selectedToggleValue) as any;

	return selectedCanvasResolution <= 1024 ? (
		<ResponsiveLayoutMobileProvider {...props}>{props.children}</ResponsiveLayoutMobileProvider>
	) : null;
};

export default ResponsiveLayoutMobile;
